import * as React from 'react';

function SvgAlert(props) {
  return (
    <svg width={16} height={17} viewBox="0 0 16 17" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8 4.872v5.463a.79.79 0 01-.8.78.79.79 0 01-.8-.78V4.872c0-.431.358-.781.8-.781.442 0 .8.35.8.78zm0 7.804a.79.79 0 01-.8.78.79.79 0 01-.8-.78c0-.43.358-.78.8-.78.442 0 .8.35.8.78zm5.6 1.849a.8.8 0 01-.8.8H2.4a.8.8 0 01-.8-.8v-11.2a.8.8 0 01.8-.8h11.2a.8.8 0 01.8.8v11.2zm0-13.561H1.6C.716.964 0 1.683 0 2.566v12.803c0 .884.716 1.595 1.6 1.595h12.8c.884 0 1.6-.714 1.6-1.598V2.569c0-.884-.8-1.605-1.6-1.605z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgAlert;
